var heading_default = {
  "fontElementMap": "DQAVD",
  "elementSpacing": "_3lOcb",
  "headerOne": "vjlMJ _3lOcb",
  "headerTwo": "oc8-D _3lOcb",
  "headerThree": "KlUhy _3lOcb",
  "headerFour": "k5lnE _3lOcb",
  "headerFive": "zvKsD _3lOcb",
  "headerSix": "XoQPM _3lOcb",
  "child": "_6a-iT"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
